import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { HttpClientCustom } from './http.client';
import * as _ from 'underscore';

@Injectable()
export class PermissionHelper {
    public permission: any = [];

    constructor() { }

    public savePermission(permissions) {
        this.permission = permissions;
    }

    public getPermission() {
        return this.permission;
    }

    public checkForPermission(permission): Boolean {
        if (this.permission.length > 0) {
            for (let i = 0; i < this.permission.length; i++) {
                if (this.permission[i] === permission) {
                    return true;
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/permissions/permissions.ts